import React, { useContext } from 'react';
import Header from '../../layout/Header/Header';
import { AuthContext } from '../../contexts/AuthContext';
import ConversationList from '../../ia/ConversationList';
import ChatPanel from '../../ia/ChatPanel';

export default function AsistenteIAPage() {
  const { isAuth, user } = useContext(AuthContext);

  // Igual que ChatWidget.jsx: ocultar en vez de redirigir. AuthContext tarda un instante en
  // re-hidratarse tras un full page reload (asi navega el menu de este proyecto), y un
  // <Navigate> aqui expulsaba al login antes de que isAuth terminara de resolverse.
  if (!isAuth || !user || !user.menu_ia) return null;

  return (
    <>
      <Header />
      <div className="container-fluid" style={{ padding: '16px' }}>
        <div
          style={{
            display: 'flex',
            height: 'calc(100vh - 160px)',
            border: '1px solid #ddd',
            borderRadius: '8px',
            overflow: 'hidden',
            backgroundColor: '#fff'
          }}
        >
          <div style={{ width: 260, flexShrink: 0, borderRight: '1px solid #eee' }} className="d-none d-sm-block">
            <ConversationList />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <ChatPanel />
          </div>
        </div>
      </div>
    </>
  );
}
